import '../Home.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFish, faAngleRight } from "@fortawesome/free-solid-svg-icons";

export default function CaughtFishCard({ onOpenReport }) {
  const navigate = useNavigate();
  return (
    <div className="card">
      <h2>Caught a tagged fish?</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <button className="report-btn" onClick={() => onOpenReport()}> 
          <FontAwesomeIcon icon={faFish} className="fish-icon" />
          Report a tagged fish
          <FontAwesomeIcon icon={faAngleRight} className = "right-arrow" />
        </button>
        <button className="view-btn"
        onClick={() => navigate('/progress')}
        >
          View reports in progress
          <FontAwesomeIcon icon={faAngleRight} className = "right-arrow" />
        </button>
      </div>
    </div>
  );
}